<script setup>
import {useViewStore} from '@/stores/view'
import {useAppStore} from '@/stores/appStore'
import param from 'jquery-param'
import Button from '@/common/Button.vue'

const appStore = useAppStore()

const getListingId = () => {
    const viewId = appStore.mainViewId
    if (viewId) {
        const viewStore = useViewStore(viewId)
        const selectedIds = viewStore.selectedIds || []
        if (selectedIds.length === 1) {
            return selectedIds[0]
        }
    }
    return undefined
}

const getParams = () => {
    const params = {}

    const stripParams = (str) => {
        return str ? str.split('?')[0] : null
    }

    // E.g. /#/site_tree?foo=bar or /#/site_tree/c174?foo=bar
    const hash = window.location.hash.split('/')
    // site_tree?foo=bar -> site_tree
    const tableName = stripParams(hash[1])
    // c174?foo=bar -> c174
    const id = stripParams(hash[2])

    params['tableName'] = tableName

    if (tableName === 'site_tree') {
        if (typeof id === 'string' && id.indexOf('c') === 0) {
            params['pageContentId'] = parseInt(id.substr(1))
        } else {
            params['pageId'] = parseInt(id)
        }
    } else if (tableName === 'pages') {
        params['pageId'] = parseInt(id) || getListingId()
    } else if (tableName === 'content') {
        params['contentId'] = parseInt(id) || getListingId()
    } else {
        params['id'] = parseInt(id) || getListingId()
    }

    params['token'] = localStorage.getItem('token')

    return params
}

const openPreviewMode = () => {
    const href = appStore.ccmsSchemeAndHost + '/controller/preview-open?' + param(getParams())
    window.open(href)
}
</script>

<template>
    <Button class="h-100 rounded-0" title="Preview website" @click="openPreviewMode">
        <i class="bi-globe"></i>
    </Button>
</template>